import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/vhe/Navbar";
import Hero from "@/components/vhe/Hero";
import Marquee from "@/components/vhe/Marquee";
import Blueprint from "@/components/vhe/Blueprint";
import Capabilities from "@/components/vhe/Capabilities";
import Pillars from "@/components/vhe/Pillars";
import Leadership from "@/components/vhe/Leadership";
import Journal from "@/components/vhe/Journal";
import Contact from "@/components/vhe/Contact";
import Footer from "@/components/vhe/Footer";
import Admin from "@/pages/Admin";

const Home = () => (
  <>
    <Navbar />
    <main id="main-content">
      <Hero />
      <Marquee />
      <Blueprint />
      <Capabilities />
      <Pillars />
      <Leadership />
      <Journal />
      <Contact />
    </main>
    <Footer />
  </>
);

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const target = document.querySelector(a.getAttribute("href"));
      if (target) {
        e.preventDefault();
        lenis.scrollTo(target, { offset: -64 });
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      document.removeEventListener("click", onClick);
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" toastOptions={{ style: { background: "#0A1428", border: "1px solid rgba(212,175,55,0.35)", color: "#FAF7F2" } }} />
    </div>
  );
}

export default App;
